import { gql } from '@apollo/client';

const FEE_CORE_FIELDS = gql`
  fragment FeeCoreFields on Fee {
    id
    type
    amount
    description
    feeFiles { id, filename, contentType, url }
    feeEstimate {
      id
      acceptedByString
      acceptMethod
      acceptedAt
    }
  }
`;

export const ASSET_FEES = gql`
  ${FEE_CORE_FIELDS}
  query AssetFees($id: ID!) {
    asset(id: $id) {
      fees {
        ...FeeCoreFields
      }
    }
  }
`;
